// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LandingsTitle_wrapper__N7uVn","title":"LandingsTitle_title__mowRx","portable":"LandingsTitle_portable__2kUrU","isTop":"LandingsTitle_isTop__BS44m"};